import * as React from "react";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  CircularProgress,
  styled,
  TextField,
  Typography,
  useTheme,
  InputAdornment,
  Divider,
  Avatar,
  IconButton,
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  DialogTitle,
  Slide,
} from "@mui/material";
import { useState, useRef } from "react";
import axios from "axios";
import { Url } from "../../Api/Api";
import { getAccessToken } from "../../hooks/useLocalStorage";
import Swal from "sweetalert2";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import SchoolIcon from "@mui/icons-material/School";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import GroupAddIcon from "@mui/icons-material/GroupAdd";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const FormRow = styled(Box)({
  display: "flex",
  alignItems: "center",
  width: "100%",
  marginBottom: "16px",
});

const FormFieldContainer = styled(Box)({
  flexGrow: 1,
  minWidth: 0,
});

const ProfileUploadContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 16,
  padding: "24px",
  backgroundColor: "#f5f5f5",
  borderRadius: "12px",
  marginBottom: "20px",
  border: "2px dashed #51B0CF",
  position: "relative",
}));

const HiddenFileInput = styled("input")({
  display: "none",
});

const ProfileImageWrapper = styled(Box)({
  position: "relative",
  display: "inline-block",
});

export default function AddAdmin(props) {
  let { fetch_AllAdmin_Data } = props;
  const [open, setOpen] = useState(false);
  const fileInputRef = useRef(null);

  const token = getAccessToken();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const [errors, setErrors] = useState({
    membersCount: "",
    phoneNumber: "",
    emailId: "",
  });

  const [profileImage, setProfileImage] = useState(null);
  const [profileImagePreview, setProfileImagePreview] = useState(null);

  const validateMembersCount = (value) => {
    if (!value) return "Member count is required";
    if (/^0+$/.test(value)) return "Member count cannot be 0";
    if (/^0+\d+$/.test(value)) return "Leading zeros are not allowed";

    const num = Number(value);
    if (num < 1 || num > 500) return "Member count must be between 1 and 500";

    return "";
  };

  const validatePhoneNumber = (value) => {
    if (!value) return "Phone number is required";
    if (!/^[6-9]\d{9}$/.test(value)) {
      return "Enter a valid phone number";
    }
    return "";
  };

  const validateEmail = (value) => {
    if (!value) return "Email is required";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      return "Enter a valid email address";
    }
    return "";
  };

  const validateProfileImage = (file) => {
    const maxSizeInMB = 5;
    const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

    if (!file) return "Profile image is required";
    if (!["image/jpeg", "image/png", "image/jpg"].includes(file.type)) {
      return "Only JPG and PNG files are allowed";
    }
    if (file.size > maxSizeInBytes) {
      return `File size must be less than ${maxSizeInMB}MB`;
    }
    return "";
  };

  const handleClose = () => {
    setOpen(false);
    setErrors({
      membersCount: "",
      phoneNumber: "",
      emailId: "",
    });
    setAdminDetails({
      institutionsName: "",
      membersCount: "",
      firstName: "",
      lastName: "",
      emailId: "",
      mobileNumber: "",
      batchName: "",
    });
    setProfileImage(null);
    setProfileImagePreview(null);
  };

  const [addLoader, setAddLoader] = useState(false);
  const [adminDetails, setAdminDetails] = useState({
    institutionsName: "",
    membersCount: "",
    batchName: "",
    adminId: 0,
    firstName: "",
    lastName: "",
    emailId: "",
    mobileNumber: "",
    role: "admin",
  });

  const HandleFromChange = (e) => {
    setAdminDetails({ ...adminDetails, [e.target.name]: e.target.value });
  };

  const handleImageUpload = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const error = validateProfileImage(file);
    if (error) {
      Swal.fire({
        icon: "error",
        title: "Invalid Image",
        text: error,
        confirmButtonColor: "#80278C",
      });
      return;
    }

    setProfileImage(file);

    // Create preview
    const reader = new FileReader();
    reader.onloadend = () => {
      setProfileImagePreview(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleRemoveImage = () => {
    setProfileImage(null);
    setProfileImagePreview(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const AddAdminPost = async (event) => {
    event.preventDefault();

    // Validate form fields
    const newErrors = {
      membersCount: validateMembersCount(adminDetails.membersCount),
      phoneNumber: validatePhoneNumber(adminDetails.mobileNumber),
      emailId: validateEmail(adminDetails.emailId),
    };

    setErrors(newErrors);

    if (newErrors.membersCount || newErrors.phoneNumber || newErrors.emailId) {
      return;
    }


    const formData = new FormData();
    formData.append("institutions_name", adminDetails.institutionsName);
    formData.append("members_count", adminDetails.membersCount);
    formData.append("batch_name", adminDetails.batchName);
    formData.append("first_name", adminDetails.firstName);
    formData.append("last_name", adminDetails.lastName);
    formData.append("email_id", adminDetails.emailId);
    formData.append("mobile_number", adminDetails.mobileNumber);
     if (profileImage) {
    formData.append("user_profile", profileImage);
    }

    try {
      setAddLoader(true);
      const res = await axios.post(Url.AddAdmin, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      if (res?.data?.status === "1") {
        fetch_AllAdmin_Data();
        handleClose();
        Swal.fire({
          icon: "success",
          title: "Success",
          text: res?.data?.message,
          draggable: false,
          iconColor: "#00BFFF",
          confirmButtonColor: "#80278C",
        });
      } else {
        handleClose();
        Swal.fire({
          icon: "warning",
          title: "Warning!",
          text: res?.data?.message,
          draggable: false,
          iconColor: "#00BFFF",
          confirmButtonColor: "#80278C",
        });
      }
    } catch (e) {
      Swal.fire({
        icon: "warning",
        title: "Warning!",
        text: "Something went wrong please try again",
        draggable: false,
        iconColor: "#00BFFF",
        confirmButtonColor: "#80278C",
      });
    } finally {
      setAddLoader(false);
    }
  };

  return (
    <React.Fragment>
      <Button
        startIcon={<AddRoundedIcon />}
        variant="contained"
        sx={{
          backgroundColor: "#51b0cfff",
          ":hover": { background: "#51b0cfff", color: "#fff" },
        }}
        onClick={handleClickOpen}
      >
        Add Admin
      </Button>
      <Dialog
        open={open}
        slots={{
          transition: Transition,
        }}
        fullWidth
        maxWidth="sm"
        keepMounted
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle
          variant="h6"
          fontWeight="bold"
          gutterBottom
          sx={{
            backgroundColor: "#51B0CF",
            color: "white",
          }}
        >
          Add Admin
        </DialogTitle>

        <DialogContent sx={{ mt: 3 }}>
          <form onSubmit={AddAdminPost} id="subscription-form">
            {/* Profile Image Upload Section */}
            <ProfileUploadContainer>
              {profileImagePreview ? (
                <ProfileImageWrapper>
                  <Avatar
                    src={profileImagePreview}
                    sx={{
                      width: 120,
                      height: 120,
                      border: "3px solid #51B0CF",
                    }}
                  />
                </ProfileImageWrapper>
              ) : (
                <Box
                  sx={{
                    textAlign: "center",
                    cursor: "pointer",
                    width: "100%",
                  }}
                  onClick={() => fileInputRef.current?.click()}
                >
                  <CloudUploadIcon
                    sx={{
                      fontSize: 48,
                      color: "#51B0CF",
                      marginBottom: 1,
                    }}
                  />
                  <Typography variant="body1" fontWeight="600" color="#002147">
                    Upload Profile Photo (Optional)
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                    JPG or PNG • Max 5MB
                  </Typography>
                </Box>
              )}

              <HiddenFileInput
                ref={fileInputRef}
                type="file"
                accept="image/jpeg,image/png,image/jpg"
                onChange={handleImageUpload}
              />
            </ProfileUploadContainer>

            {/* First Name & Last Name */}
            <FormRow>
              <FormFieldContainer
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <TextField
                  variant="outlined"
                  size="medium"
                  fullWidth
                  name="firstName"
                  value={adminDetails.firstName}
                  onChange={HandleFromChange}
                  placeholder="First Name"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "background.paper",
                      fontSize: "14px",
                      borderRadius: "8px",
                    },
                  }}
                  required
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start" sx={{ gap: 1 }}>
                        <PersonIcon sx={{ color: "#002147" }} />
                        <Divider
                          orientation="vertical"
                          flexItem
                          sx={{ mx: 1, borderColor: "#ccc" }}
                        />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  variant="outlined"
                  size="medium"
                  fullWidth
                  name="lastName"
                  value={adminDetails.lastName}
                  onChange={HandleFromChange}
                  placeholder="Last Name"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "background.paper",
                      fontSize: "14px",
                      borderRadius: "8px",
                    },
                  }}
                  required
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start" sx={{ gap: 1 }}>
                        <PersonIcon sx={{ color: "#002147" }} />
                        <Divider
                          orientation="vertical"
                          flexItem
                          sx={{ mx: 1, borderColor: "#ccc" }}
                        />
                      </InputAdornment>
                    ),
                  }}
                />
              </FormFieldContainer>
            </FormRow>

            {/* Institution Name */}
            <FormRow>
              <FormFieldContainer>
                <TextField
                  variant="outlined"
                  size="medium"
                  fullWidth
                  name="institutionsName"
                  value={adminDetails.institutionsName}
                  onChange={HandleFromChange}
                  placeholder="Enter Institution Name"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "background.paper",
                      fontSize: "14px",
                      borderRadius: "8px",
                    },
                  }}
                  required
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start" sx={{ gap: 1 }}>
                        <SchoolIcon sx={{ color: "#002147" }} />
                        <Divider
                          orientation="vertical"
                          flexItem
                          sx={{ mx: 1, borderColor: "#ccc" }}
                        />
                      </InputAdornment>
                    ),
                  }}
                />
              </FormFieldContainer>
            </FormRow>

            {/* Email */}
            <FormRow>
              <FormFieldContainer>
                <TextField
                  variant="outlined"
                  size="medium"
                  fullWidth
                  name="emailId"
                  type="email"
                  value={adminDetails.emailId}
                  onChange={(e) => {
                    HandleFromChange(e);
                    setErrors((prev) => ({
                      ...prev,
                      emailId: validateEmail(e.target.value),
                    }));
                  }}
                  onBlur={(e) =>
                    setErrors((prev) => ({
                      ...prev,
                      emailId: validateEmail(e.target.value),
                    }))
                  }
                  error={!!errors.emailId}
                  helperText={errors.emailId}
                  placeholder="xyz@gmail.com"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "background.paper",
                      fontSize: "14px",
                      borderRadius: "8px",
                    },
                  }}
                  required
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start" sx={{ gap: 1 }}>
                        <EmailIcon sx={{ color: "#002147" }} />
                        <Divider
                          orientation="vertical"
                          flexItem
                          sx={{ mx: 1, borderColor: "#ccc" }}
                        />
                      </InputAdornment>
                    ),
                  }}
                />
              </FormFieldContainer>
            </FormRow>

            {/* Phone Number */}
            <FormRow>
              <FormFieldContainer>
                <TextField
                  variant="outlined"
                  size="medium"
                  fullWidth
                  type="tel"
                  name="mobileNumber"
                  value={adminDetails.mobileNumber}
                  onChange={(e) => {
                    const cleaned = e.target.value.replace(/\D/g, "");

                    if (cleaned.length <= 10) {
                      HandleFromChange({
                        target: { name: "mobileNumber", value: cleaned },
                      });

                      setErrors((prev) => ({
                        ...prev,
                        phoneNumber: validatePhoneNumber(cleaned),
                      }));
                    }
                  }}
                  onBlur={(e) =>
                    setErrors((prev) => ({
                      ...prev,
                      phoneNumber: validatePhoneNumber(e.target.value),
                    }))
                  }
                  inputProps={{ maxLength: 10, inputMode: "numeric" }}
                  error={!!errors.phoneNumber}
                  helperText={errors.phoneNumber}
                  placeholder="xxxxx xxxxx"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "background.paper",
                      fontSize: "14px",
                      borderRadius: "8px",
                    },
                  }}
                  required
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start" sx={{ gap: 1 }}>
                        <LocalPhoneIcon sx={{ color: "#002147" }} />
                        <Divider
                          orientation="vertical"
                          flexItem
                          sx={{ mx: 1, borderColor: "#ccc" }}
                        />
                      </InputAdornment>
                    ),
                  }}
                />
              </FormFieldContainer>
            </FormRow>

            {/* Batch Name */}
            <FormRow>
              <FormFieldContainer>
                <TextField
                  variant="outlined"
                  size="medium"
                  fullWidth
                  name="batchName"
                  value={adminDetails.batchName}
                  onChange={HandleFromChange}
                  placeholder="Enter Batch Name"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "background.paper",
                      fontSize: "14px",
                      borderRadius: "8px",
                    },
                  }}
                  required
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start" sx={{ gap: 1 }}>
                        <Diversity3Icon sx={{ color: "#002147" }} />
                        <Divider
                          orientation="vertical"
                          flexItem
                          sx={{ mx: 1, borderColor: "#ccc" }}
                        />
                      </InputAdornment>
                    ),
                  }}
                />
              </FormFieldContainer>
            </FormRow>

            {/* Members Count */}
            <FormRow>
              <FormFieldContainer>
                <TextField
                  type="tel"
                  variant="outlined"
                  size="medium"
                  fullWidth
                  name="membersCount"
                  value={adminDetails.membersCount}
                  onChange={(e) => {
                    const cleaned = e.target.value.replace(/\D/g, "");
                    if (cleaned.length <= 3) {
                      HandleFromChange({
                        target: { name: "membersCount", value: cleaned },
                      });

                      setErrors((prev) => ({
                        ...prev,
                        membersCount: validateMembersCount(cleaned),
                      }));
                    }
                  }}
                  onBlur={(e) =>
                    setErrors((prev) => ({
                      ...prev,
                      membersCount: validateMembersCount(e.target.value),
                    }))
                  }
                  inputProps={{
                    maxLength: 3,
                    inputMode: "numeric",
                  }}
                  placeholder="Enter Members Count"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "background.paper",
                      fontSize: "14px",
                      borderRadius: "8px",
                    },
                  }}
                  required
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start" sx={{ gap: 1 }}>
                        <GroupAddIcon sx={{ color: "#002147" }} />
                        <Divider
                          orientation="vertical"
                          flexItem
                          sx={{ mx: 1, borderColor: "#ccc" }}
                        />
                      </InputAdornment>
                    ),
                  }}
                  error={!!errors.membersCount}
                  helperText={errors.membersCount}
                />
              </FormFieldContainer>
            </FormRow>
          </form>
        </DialogContent>

        <DialogActions
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            p: 3,
          }}
        >
          <Button
            disabled={addLoader}
            size="medium"
            sx={{
              width: 90,
              borderRadius: "8px",
              color: "#51B0CF",
              border: "1px solid #51B0CF",
            }}
            variant="outlined"
            onClick={handleClose}
          >
            Close
          </Button>
          <Button
            disabled={addLoader}
            type="submit"
            size="medium"
            form="subscription-form"
            sx={{
              width: 120,
              borderRadius: "8px",
              background: "#51B0CF",
              ":hover": { backgroundColor: "#51B0CF", color: "white" },
            }}
            variant="contained"
          >
            {addLoader ? <CircularProgress size={28} color="inherit" /> : "Add"}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
